// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"_2n-feEDulyJP6w8Ui0dVG4","headerTitle":"_2EAckx3WmV1Mrp9sUQ1dN1","copy":"UpAeKVZD755XjZfRLyCaA","answerButton":"_3JgeMp7Nu7AynfnCk4f6R5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/TestResult.css
// module id = 811
// module chunks = 0